import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  cargarCalificacionesFuncionario,
  listaPendientesValidar,
} from "../../utils/Datos";
import { Textos, UrlWs } from "../../utils/Global";
import { PlaceholderTabla } from "../Otros/Placeholder";

export const EvaluacionesPrecalificacionesPorValidar = ({ id_participant }) => {
  const [datos, setDatos] = useState(null);
  const [calificacion, setCalificacion] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (id_participant != null) {
      setCargandoDatos(true);
      if (cargandoDatos === false) {
        cargarCalificacionesFuncionario(id_participant).then(
          (datosCalifificacion) => {
           
            setCalificacion(datosCalifificacion);
            console.log(datosCalifificacion);
          }
        );
        listaPendientesValidar(id_participant).then((datosPendientes) => {
          setCargandoDatos(false);
          setDatos(datosPendientes);
        });
      }
    }
  }, [id_participant]);

  const onClick = (id_participant, id_precalifiacion) => {
    const url = `/validarEvaluacion/${id_participant}/${id_precalifiacion}`;
    navigate(url, {});
  };
  const onClickCalificacion = (id_participant, id_precalifiacion) => {
    const url = `/aceptarCalificacion`;
    navigate(url, {});
  };

  return (
    <div className="card-body ">
      <div className="table-responsive">
        {datos === null || cargandoDatos ? (
          <PlaceholderTabla></PlaceholderTabla>
        ) : (
          <>
            <table className="table table-rounded table-striped border gy-7 gs-7">
              <thead>
                <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                  <th>Etapa</th>
                  <th>Rut</th>
                  <th>Nombre</th>
                  <th>Dirección</th>
                  <th>Unidad</th>
                  <th>{Textos.comun_Precalificador}</th>
                  <th>Validar</th>
                </tr>
              </thead>
              <tbody>
                {datos.filter((dato) => dato.statusValidationFun == false)
                  .length <= 0 ? (
                  <tr>
                    <td colSpan={7}>
                      No hay evaluaciones/precalificaciones pendientes para
                      validar
                    </td>
                  </tr>
                ) : (
                  datos
                    .filter((dato) => dato.statusValidationFun == false)
                    .map((d) => {
                      return (
                        <tr key={d.id_preQualifications}>
                          <td>{d.nameStage}</td>
                          <td>{d.rutOfficer}</td>
                          <td>{d.nameOfficer}</td>
                          <td>{d.nameMunicipalDirection}</td>
                          <td>{d.nameMunicipalUnit}</td>
                          <td>{d.prequalifierName}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() =>
                                onClick(
                                  d.id_participant,
                                  d.id_preQualifications
                                )
                              }
                            >
                              {/**/} Validar
                            </button>
                          </td>
                        </tr>
                      );
                    })
                )}
              </tbody>
            </table>

            {calificacion != null &&
            calificacion.status == true &&
            calificacion.datos != null &&
            calificacion.datos.ratification != false &&
            calificacion.datos.isNotified == true &&
            calificacion.datos.accordanceStatus == null
            ? (
              <>
                <h3 className="tituloMedio">Calificación</h3>
                <table className="table table-rounded table-striped border gy-7 gs-7">
                  <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                      <th>Lista</th>
                      <th>Nota final</th>
                      <th>Validar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {calificacion.datos != null &&
                    calificacion.datos.length <= 0 ? (
                      <tr>
                        <td colSpan={7}>No hay datos para mostrar</td>
                      </tr>
                    ) : (
                      <>
                        {calificacion == null ? (
                          <>
                            <tr>
                              <td colSpan={3}>
                                No hay calificaciones pendientes para validar.
                              </td>
                            </tr>
                          </>
                        ) : calificacion.datos.accordanceStatus==null ? (
                          <tr key={calificacion.datos.id_qualifications}>
                            <td>{calificacion.datos.list}</td>
                            <td>{calificacion.datos.finalScore}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() =>
                                  onClickCalificacion(
                                    calificacion.datos.id_participant,
                                    calificacion.datos.id_qualifications
                                  )
                                }
                              >
                                 Aceptar calificación
                              </button>
                            </td>
                          </tr>
                        ) : <>
                             <tr>
                              <td colSpan={3}>
                                No hay calificaciones pendientes para validar.
                              </td>
                            </tr>
                          </>}
                      </>
                    )}
                  </tbody>
                </table>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </div>
  );
};
